"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpayUserItemToJSON = exports.DpayUserItemFromJSONTyped = exports.DpayUserItemFromJSON = void 0;
function DpayUserItemFromJSON(json) {
    return DpayUserItemFromJSONTyped(json, false);
}
exports.DpayUserItemFromJSON = DpayUserItemFromJSON;
function DpayUserItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user_info': json['user_info'],
        'totalDpay': json['totalDpay'],
    };
}
exports.DpayUserItemFromJSONTyped = DpayUserItemFromJSONTyped;
function DpayUserItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_info': value.user_info,
        'totalDpay': value.totalDpay,
    };
}
exports.DpayUserItemToJSON = DpayUserItemToJSON;
